/* unplugin-vue-components disabled */// extracted by css-extract-rspack-plugin
export default {"text":"register-privacy-checkbox_text__oQ9be","button":"register-privacy-checkbox_button__QSYuC"};